import * as React from 'react';
import './ErrorMessage.pcss';

export const ErrorMessage = (props:{message:string, title?:string, subtitle?:string, iconName?:string}) => 
  <div className="errorMessage">
    <i className="material-icons">{props.iconName?props.iconName:'error_outline'}</i>
    <h2>{props.title?props.title:'Error'}</h2>
    {props.subtitle && <h3>{props.subtitle}</h3> }
    <p>{props.message}</p>
  </div>
;